export enum BulkActionPosition {
  Left = 'left',
  Right = 'right'
}

